export const SPACING = 8;

export const ICON_SIZE = 13;

export const TOOLTIP_ICON_SIZE = 11;

export const ICON_MARGIN_RIGHT = SPACING;

export const SCALAR_TITLE_LINE_HEIGHT = 23;

export const MIN_PREVIOUS_VALUE_SIZE = 27;

export const MAX_PREVIOUS_VALUE_SIZE = 42;

export const TITLE_2_LINES_HEIGHT_THRESHOLD = 150; // determined empirically
